import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router.js'

const app = createApp(App)

router.beforeEach((to, from, next) => {
    console.log(`Navigating to: ${to.path}`);
    next(); // 确保调用 next() 以继续导航
});
app.use(router);
app.use(ElementPlus, { size: 'small', zIndex: 3000 });
app.mount('#app');